import { useTranslation } from 'react-i18next';
import ProductLink from '../../ProductLink';
import PropTypes from 'prop-types';
import { productShape } from '../../../../../hooks/useAnalytics/useAnalytics.proptypes';

const ViewReplacementActions = ({ url, productClickDetails, gaListName }) => {
  const [t] = useTranslation();
  return (
    <ProductLink
      className="btn btn-dynamic btn-tertiary w-100 my-1 text-break py-lg-2 py-3 px-3"
      link={url}
      productClickDetails={productClickDetails}
      gaListName={gaListName}
    >
      {t('VIEW_REPLACEMENT')}
    </ProductLink>
  );
};

export default ViewReplacementActions;

ViewReplacementActions.propTypes = {
  gaListName: PropTypes.string,
  url: PropTypes.string.isRequired,
  productClickDetails: PropTypes.arrayOf(productShape)
};
